export default __webpack_public_path__ + "static/media/cactus.a71c2062.jpg";